import {
  Box,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField
} from '@mui/material';
import { useState } from 'react';
import { GridSearchIcon } from '@mui/x-data-grid';

interface IFilterProps {
  projectRoles: Array<{ id: string; displayName: string; role: string }>;
  onFilterChange: (filters: {
    searchText: string;
    selectedRole: string;
  }) => void;
}

const ProjectDataFilter = ({
  projectRoles,
  onFilterChange
}: IFilterProps): JSX.Element => {
  const [searchText, setSearchText] = useState<string>('');
  const [selectedRole, setSelectedRole] = useState<string>('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newSearchText = e.target.value;
    setSearchText(newSearchText);
    onFilterChange({ searchText: newSearchText, selectedRole });
  };

  const handleRoleChange = (event: SelectChangeEvent<string>): void => {
    const newSelectedRole = event.target.value;
    setSelectedRole(newSelectedRole);
    onFilterChange({ searchText, selectedRole: newSelectedRole });
  };

  return (
    <Box sx={{ display: 'flex', marginRight: '50px' }}>
      <TextField
        sx={{
          fontFamily: 'Be Vietnam Pro',
          fontSize: '16px',
          fontWeight: '500',
          lineHeight: '20px',
          letterSpacing: '0px',
          textAlign: 'left',
          '& .MuiOutlinedInput-root': {
            height: '48px',
            borderRadius: '8px',
            width: '220%'
          }
        }}
        id="search-bar"
        variant="outlined"
        placeholder="Search"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <GridSearchIcon />
            </InputAdornment>
          )
        }}
      />
      <FormControl
        variant="outlined"
        sx={{ width: '100%', marginLeft: '180px', paddingBottom: '20px' }}
      >
        <InputLabel id="filter-by-role-label" sx={{ top: '-2.5px' }}>
          Filter By Role
        </InputLabel>
        <Select
          sx={{
            width: '200px',
            height: '48px',
            padding: '12px',
            borderRadius: '8px',
            border: '1px'
          }}
          value={selectedRole}
          onChange={handleRoleChange}
          label="Filter By Role"
        >
          {projectRoles.map((projectRole) => (
            <MenuItem key={projectRole.id} value={projectRole.role}>
              {projectRole.displayName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ProjectDataFilter;
